// Textes
const hideText = {
    "fr-FR": {
        tel: "Afficher le numéro",
        mail: "Voir l'email",
        address: "Afficher l'adresse"
    },
    "en-US": {
        tel: "Show the number",
        mail: "Show the email",
        address: "Show address"
    },
    "nl-NL": {
        tel: "Zie nummer",
        mail: "Zie email",
        address: "Adres tonen"
    },
    "es-ES": {
        tel: "Ver numero",
        mail: "Ver email",
        address: "Mostrar dirección"
    }
};

function hideLink(selector, type, lang) {
    document.querySelectorAll(selector).forEach((el) => {
        if (el.innerHTML !== '') {
            el.classList.add(`pdw-${type}-hidden`);
            el.dataset.dataHref = el.href;
            el.dataset.dataContent = el.innerHTML;
            el.removeAttribute('href');
            el.innerHTML = hideText[lang][type];

            el.addEventListener('click', function handleClick(e) {
                e.preventDefault();
                e.target.innerHTML = e.target.dataset.dataContent;
                e.target.href = e.target.dataset.dataHref;
                e.target.classList.remove(`pdw-${type}-hidden`);
                e.target.removeEventListener('click', handleClick);
            });
        }
    });
}

// DOM loaded
document.addEventListener("DOMContentLoaded", () => {
    let pageLang = document.documentElement.lang;

    hideLink('a[href^="tel:"]', 'tel', pageLang);
    hideLink('a[href^="mailto:"]', 'mail', pageLang);
    hideLink('a[href^="https://maps.google.com"], a[href^="https://www.google.com/maps"]', 'address', pageLang);
});